module.exports = __webpack_public_path__ + "img/code-pull-request.231eacef.svg";